<!-- <p>employee-registration-form works!</p> -->
<div
  class="visitor-pass-container"
  [ngStyle]="screenSize == ScreenType.Mobile ? {} : { height: '100%' }"
>
  <mat-card class="visitor-pass-card">
    <mat-card-header class="visitor-pass-card-header"
      >Employee Registration Form</mat-card-header
    >
    <mat-card-content class="visitor-pass-card-content">
      <form [formGroup]="employeeForm">
        <mat-grid-list
          [cols]="screenSize == ScreenType.Mobile ? 1 : 2"
          rowHeight="70px"
          gutterSize="15px"
        >
          <mat-grid-tile rowspan="4">
            <div id="visitorQR" class="visitor-pass-identity">
              <mat-progress-bar
                mode="determinate"
                [value]="uploadProgressId"
              ></mat-progress-bar>
              <div class="visitor-image-container">
                <img [src]="urlID" alt="Upload ID" />
              </div>
              <div class="upload-button-label">
                <label for="idpic" class="upload-button-label"
                  >{{ urlID ? "Change ID" : "Upload ID" }}
                </label>
                <input
                  [disabled]="isFaceMatched"
                  (click)="uploadProgressId = 0"
                  style="display: none"
                  id="idpic"
                  (change)="onUploadID($event)"
                  type="file"
                  accept="image/*"
                />
              </div>
            </div>
          </mat-grid-tile>
          <mat-grid-tile rowspan="4">
            <div class="visitor-pass-identity">
              <mat-progress-bar
                mode="determinate"
                [value]="uploadProgressProfile"
              ></mat-progress-bar>
              <div class="visitor-image-container">
                <img [src]="urlProfile" alt="Upload photo" />
              </div>
              <div class="upload-button-label">
                <label for="profilepic" class="upload-button-label">{{
                  urlProfile ? "Change Profile" : "Upload Profile"
                }}</label>
                <input
                  [disabled]="isFaceMatched"
                  (click)="uploadProgressProfile = 0"
                  style="display: none"
                  id="profilepic"
                  (change)="onUploadProfile($event)"
                  type="file"
                  name=""
                  accept="image/*"
                />
              </div>
            </div>
          </mat-grid-tile>
          <mat-grid-tile>
            <button
              type="button"
              (click)="onSelfVerifyEmployee()"
              mat-raised-button
              [disabled]="!(urlProfile && urlProfile)"
            >
              {{ "Self Verify" }}
            </button></mat-grid-tile
          >
          <mat-grid-tile *ngIf="showMsg">
            <div
              [ngStyle]="
                isFaceMatched
                  ? { 'background-color': 'green' }
                  : { 'background-color': 'red' }
              "
              *ngIf="!isAPIRequest"
              class="display-message"
            >
              {{ faceMatchMsg | titlecase }}
            </div>
            <div *ngIf="isAPIRequest">
              <mat-spinner [diameter]="62"></mat-spinner>
            </div>
          </mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>First Name</mat-label>
              <input
                (input)="transformInput(employeeForm.get('firstName'))"
                matInput
                formControlName="firstName"
              /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Last Name</mat-label>
              <input
                (input)="transformInput(employeeForm.get('lastName'))"
                matInput
                formControlName="lastName"
              /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Employee Email</mat-label>
              <input matInput formControlName="email" /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <ngx-mat-intl-tel-input
                #phoneInput
                [enablePlaceholder]="true"
                [required]="true"
                [preferredCountries]="['in']"
                [enableSearch]="true"
                name="phone"
                formControlName="phoneNumber"
                [inputPlaceholder]="'Phone Number *'"
                [label]="'Phone Number'"
                [maxlength]="15"
                (change)="onChangeNumber($event)"
              ></ngx-mat-intl-tel-input>
              <mat-error
                *ngIf="employeeForm.controls['phoneNumber']?.errors?.['validatePhoneNumber']
                &&
                false"
                ><i>Enter valid number</i>
              </mat-error>
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Employee Address</mat-label>
              <input
                matInput
                formControlName="employeeAddress"
              /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile *ngIf="false"
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Employee Id</mat-label>
              <input matInput formControlName="employeeId" /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Employee Department</mat-label>
              <input
                matInput
                formControlName="employeeDepartment"
              /> </mat-form-field
          ></mat-grid-tile>

          <mat-grid-tile>
            <button
              [ngStyle]="
                isSaveRequest
                  ? { 'background-color': '#FEF5F9', color: 'black' }
                  : {}
              "
              (click)="onSaveEmployeeInformation()"
              [disabled]="employeeForm.invalid || !isFaceMatched"
              mat-raised-button
            >
              <span style="display: flex; align-items: center"
                >{{ isSaveRequest ? "Saving..." : "Save" }}
                <mat-spinner *ngIf="isSaveRequest" [diameter]="40"></mat-spinner
              ></span></button
          ></mat-grid-tile>
        </mat-grid-list>
      </form>
    </mat-card-content>
  </mat-card>
</div>
<ng-template #EmployeeDetailsSavedDialog>
  <h2 matDialogTitle>Employee Registration</h2>
  <mat-dialog-content>
    <div>
      <b
        ><i> {{ "Details Saved! You can close this tab" }}</i></b
      >
    </div>
  </mat-dialog-content>
</ng-template>
<ng-template #EmployeeAlreadyExistsDialog>
  <h2 matDialogTitle>Employee Registration</h2>
  <mat-dialog-content>
    <div>
      <b
        ><i> {{ "Employee Already Exists" }}</i></b
      >
    </div>
  </mat-dialog-content>
</ng-template>
